import React, { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '../authConfig';

interface AuthenticatedAppProps {
  children: React.ReactNode;
}

/**
 * Component that wraps the app and handles authentication
 */
const AuthenticatedApp: React.FC<AuthenticatedAppProps> = ({ children }) => {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    // If no user is signed in and we're not in the middle of an interaction, redirect to login
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      instance.loginRedirect(loginRequest).catch((e) => {
        console.error('Login failed:', e);
      });
    }
  }, [isAuthenticated, inProgress, instance]);

  // Show loading state while checking authentication
  if (inProgress !== InteractionStatus.None) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: 'Barlow, sans-serif'
      }}>
        <div>Authenticating...</div>
      </div>
    );
  }

  // Show message if not authenticated
  if (!isAuthenticated) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: 'Barlow, sans-serif'
      }}>
        <div>User Not Authenticated. Redirecting to login...</div>
      </div>
    );
  }

  // User is authenticated, render the app
  return <>{children}</>;
};

export default AuthenticatedApp;
